import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { LayoutNames } from '~/constants/appSettingsTypes'

const selfContainedPages = [
  '/signup-complete',
  '/verify-email',
  '/accept-terms',
]

const customLayoutPages = [
  '/copilot',
]

const determineLayout = (to: RouteLocationNormalizedGeneric): LayoutNames | null => {
  if (selfContainedPages.includes(to.path)) {
    return null
  }
  
  if (customLayoutPages.some(page => to.path === page || to.path.startsWith(`${page}/`))) {
    return null
  }
  
  let layoutName
  
  if (
    to.path === '/' ||
    to.path === '/forgotPassword' ||
    to.path === '/login' ||
    to.path === '/signup' ||
    to.path === '/reset-password' ||
    to.path.startsWith('/signup/') ||
    to.path.startsWith('/oidc/')
  ) {
    layoutName = LayoutNames.AuthForm
  } else {
    layoutName = LayoutNames.InProduct
  }

  return layoutName
}

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.dev && to.meta.publicHelpPreview === true) {
    return
  }

  // Determine the layout based on the route
  const layoutName = determineLayout(to)

  // Only set the layout if one is determined (not null)
  if (layoutName !== null) {
    setPageLayout(layoutName)
  }
})
